import { Language } from '../models/language';

export class Preferences {
  constructor(public language: Language) {}
}

export class UpdatePreferences {
  constructor(public languageId: number) {}
}
